import { request, errorText, openBlob } from "../api";

// /api/accounting/invoicing — invoices, open items, dunning
export const listInvoices = params => request.get("/invoicing", params);
export const getInvoice = id => request.get(`/invoicing/${id}`);
export const createInvoice = body => request.post("/invoicing", body);
export const updateInvoice = (id, body) => request.put(`/invoicing/${id}`, body);
export const previewTotals = body => request.post("/invoicing/preview-totals", body);
export const sendInvoice = (id, body) => request.post(`/invoicing/${id}/send`, body || {});
export const cancelInvoice = (id, body) => request.post(`/invoicing/${id}/cancel`, body || {});
export const createCreditNote = (id, body) =>
  request.post(`/invoicing/${id}/credit-note`, body || {});
export const emailInvoice = (id, body) => request.post(`/invoicing/${id}/email`, body || {});
export const invoicePdf = (id, params) => request.blob(`/invoicing/${id}/pdf`, params);
export const invoiceXml = (id, params) => request.blob(`/invoicing/${id}/einvoice.xml`, params);
export const validateInvoice = id => request.post(`/invoicing/${id}/validate`);
export const relatedCandidates = params => request.get("/invoicing/related-candidates", params);
export const customerDefaults = id => request.get(`/invoicing/customers/${id || "none"}/defaults`);
export const openItems = params => request.get("/invoicing/open-items", params);

export const listRuns = () => request.get("/invoicing/dunning/runs");
export const proposeRun = body => request.post("/invoicing/dunning/propose", body || {});
export const getRun = id => request.get(`/invoicing/dunning/runs/${id}`);
export const confirmRun = (id, body) => request.post(`/invoicing/dunning/runs/${id}/confirm`, body);
export const proposalPdf = (runId, invoiceId) =>
  request.blob(`/invoicing/dunning/runs/${runId}/proposals/${invoiceId}/pdf`);
export const blockInvoiceDunning = (id, blocked) =>
  request.put(`/invoicing/dunning/invoices/${id}/block`, { blocked });
export const blockCustomerDunning = (id, blocked) =>
  request.put(`/invoicing/dunning/customers/${id}/block`, { blocked });

// Rechnungskorrektur / Rechnungsberichtigung / Pflichtangaben
export const creditable = id => request.get(`/invoicing/${id}/creditable`);
export const createStandaloneCorrection = body => request.post("/invoicing/corrections", body);
export const createCorrectionNotice = (id, body) =>
  request.post(`/invoicing/${id}/correction-notice`, body || {});
export const preflight = id => request.get(`/invoicing/${id}/preflight`);
export const invoiceChain = id => request.get(`/invoicing/${id}/chain`);

// Payments outside bank matching, reversals, write-offs
export const listInvoicePayments = id => request.get(`/invoicing/${id}/payments`);
export const recordPayment = (id, body) => request.post(`/invoicing/${id}/payments`, body);
export const reversePayment = (paymentId, body) =>
  request.post(`/invoicing/payments/${paymentId}/reverse`, body || {});
export const writeOffInvoice = (id, body) => request.post(`/invoicing/${id}/write-off`, body);
export const waiveCharges = (id, body) =>
  request.post(`/invoicing/${id}/waive-charges`, body || {});

// Customer credits and the customer account
export const listCredits = params => request.get("/invoicing/credits", params);
export const offsetCredit = (id, body) => request.post(`/invoicing/credits/${id}/offset`, body);
export const refundCredit = (id, body) => request.post(`/invoicing/credits/${id}/refund`, body);
export const refundBatchXml = batchId => request.blob(`/invoicing/credits/batches/${batchId}/xml`);
export const customerAccount = id => request.get(`/invoicing/customers/${id}/account`);
export const markInsolvent = (id, body) =>
  request.post(`/invoicing/customers/${id}/insolvency`, body);
export const updateCustomerReceivablesData = (id, body) =>
  request.put(`/invoicing/customers/${id}/receivables-data`, body);

/** Structured error of the invoicing API: { message, code, details }. */
export const errorInfo = error => ({
  message: errorText(error),
  code: error?.response?.data?.code || null,
  details: error?.response?.data?.details
});

export { errorText, openBlob };
